import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory();

let previous = 0;
const _push = history.push;
const _goBack = history.goBack;

history.push = (path, state) => {
  previous += 1;
  _push(path, state);
};

history.goBack = (params = {}) => {
  if (previous > 0) {
    previous -= 1;
    _goBack();
  } else {
    const noHistoryUrl = params.noHistoryUrl || '/';
    history.push(noHistoryUrl);
  }
};
export default history;
